import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6321460c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-center" }
const _hoisted_3 = { class: "footer-link" }
const _hoisted_4 = { class: "footer-copyright" }
const _hoisted_5 = { href: "https://beian.miit.gov.cn" }

import { onBeforeMount, ref } from 'vue'
import { getFooterLink } from '@/api/common'
import { FooterLinkConfig } from '@/types'
import { ERR_OK } from '@/api/config'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const linkList = ref<FooterLinkConfig[]>([])
const currentDomain = window.location.hostname.replace('www.', '')
const recordNumber = currentDomain === 'ke.video' ? '京ICP备05035325号-7' : '京ICP备05035325号-6'
onBeforeMount(async () => {
  const {
    code,
    data
  } = await getFooterLink()
  if (code === ERR_OK && data) {
    linkList.value = data
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "footer-link-item"
          }, [
            _createVNode(_component_router_link, {
              target: item.target,
              title: item.title,
              to: item.url,
              class: "footer-link-item-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["target", "title", "to"])
          ]))
        }), 128))
      ]),
      _createElementVNode("p", _hoisted_4, [
        _createElementVNode("span", null, "© 2024 " + _toDisplayString(_unref(currentDomain)), 1),
        _createTextVNode(),
        _createElementVNode("a", _hoisted_5, _toDisplayString(_unref(recordNumber)), 1)
      ])
    ])
  ]))
}
}

})